import React, { useCallback, useState } from 'react'
import styled from 'react-emotion'
import { CSSTransition } from 'react-transition-group'

import AnimateAutoHeight from 'components/AnimateAutoHeight'
import CollapsableCard from 'components/CollapsableCard'

const ANIMATION_DURATION = 300

export default function NavigatableIntegrationWidgetCard(props) {
  const {
    detailComponent: DetailComponent,
    image,
    indexComponent: IndexComponent,
    title,
    persistenceKey,
  } = props
  const [state, setState] = useState(null)
  const [deferedState, setDeferedState] = useState(null)
  const setStateAndDeferedState = useCallback(
    newState => {
      setState(newState)
      const timeout = setTimeout(
        () => setDeferedState(newState),
        ANIMATION_DURATION
      )
      return () => clearTimeout(timeout)
    },
    [setState, setDeferedState]
  )
  const setStateNow = useCallback(
    newState => {
      setState(newState)
      setDeferedState(newState)
    },
    [setState, setDeferedState]
  )
  const doNavigatableClearState = useCallback(
    () => setStateAndDeferedState(null),
    [setStateAndDeferedState]
  )

  return (
    <CollapsableCard
      image={image}
      persistenceKey={persistenceKey}
      title={title}
    >
      <AnimateAutoHeight duration={ANIMATION_DURATION}>
        <AnimatedLeftRight>
          <CSSTransition
            className="index"
            classNames="index"
            in={state === null}
            unmountOnExit
            timeout={ANIMATION_DURATION}
          >
            <div>
              <IndexComponent
                doNavigatableClearState={doNavigatableClearState}
                doNavigatableSetState={setStateNow}
                navigatableState={deferedState}
                {...props}
              />
            </div>
          </CSSTransition>
          <CSSTransition
            className="detail"
            classNames="detail"
            in={state !== null}
            unmountOnExit
            timeout={ANIMATION_DURATION}
          >
            <div>
              <DetailComponent
                doNavigatableClearState={doNavigatableClearState}
                doNavigatableSetState={setStateNow}
                navigatableState={deferedState}
                {...props}
              />
            </div>
          </CSSTransition>
        </AnimatedLeftRight>
      </AnimateAutoHeight>
    </CollapsableCard>
  )
}

const AnimatedLeftRight = styled('div')`
  display: flex;

  .index,
  .detail {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 100%;
    transition: transform ease-in-out ${ANIMATION_DURATION}ms;
    min-width: 0;
  }

  .detail,
  .detail-enter {
    transform: translateX(calc(100% + 16px));
  }

  .index {
    margin-right: -100%;
  }

  .index-exit,
  .index-enter {
    transform: translateX(calc(-100% - 16px));
  }

  .index-enter-active,
  .index-enter-done {
    transform: translateX(0);
  }

  .detail-enter-active,
  .detail-enter-done {
    transform: translateX(0);
  }

  .detail-exit-active,
  .detail-exit-done,
  .index-exit-active,
  .index-exit-done {
    height: 0;
  }
`
